<p
  class="table-description p-t-md p-x m-a-0 white"
  translate>PHONE.AGENT_ONLINE.HEADER</p>
<div class="p-a sm-down-p-x-0 white">
  <div class="white b-a settings-table">
    <div class="incoming-header d-flex b-b">
      <div
        [class.active]="isActive(options[0])"
        [class.disabled]="isDisabled(options[0])"
        (click)="selectState(options[0])"
        translate>PHONE.AGENT_ONLINE.RANDOM_CASCADE
      </div>
      <div
        [class.active]="isActive(options[1])"
        [class.disabled]="isDisabled(options[1])"
        (click)="selectState(options[1])"
        translate>PHONE.AGENT_ONLINE.LONGEST_IDLE
      </div>
      <div
        [class.active]="isActive(options[2])"
        [class.disabled]="isDisabled(options[2])"
        (click)="selectState(options[2])"
        translate>PHONE.AGENT_ONLINE.SIMULTANEOUS
      </div>
    </div>
    <div class="p-a">
      <cc-random-cascade *ngIf="isActive(options[0])"></cc-random-cascade>
      <cc-longest-idle *ngIf="isActive(options[1])"></cc-longest-idle>
      <cc-simultaneous-calls *ngIf="isActive(options[2])"></cc-simultaneous-calls>
    </div>
  </div>
</div>

